import { render, staticRenderFns } from "./PgaExpertisesTable.vue?vue&type=template&id=31504e0d&"
import script from "./PgaExpertisesTable.vue?vue&type=script&lang=ts&"
export * from "./PgaExpertisesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31504e0d')) {
      api.createRecord('31504e0d', component.options)
    } else {
      api.reload('31504e0d', component.options)
    }
    module.hot.accept("./PgaExpertisesTable.vue?vue&type=template&id=31504e0d&", function () {
      api.rerender('31504e0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Resource/Expertises/Components/PgaExpertisesTable.vue"
export default component.exports